var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5967 1.73979C4.88657 1.14465 3.8285 1.2302 3.2897 1.98397C3.14578 2.18531 2.97524 2.42545 2.68069 2.7939C1.6674 4.06142 1.6674 5.89676 2.68629 7.15978C3.43845 8.09217 4.22708 9.03299 5.10867 9.91458C5.99026 10.7962 6.93109 11.5848 7.86347 12.337C9.1265 13.3558 10.9618 13.3559 12.2293 12.3426C12.6225 12.0283 12.8677 11.857 13.0759 11.7084C13.804 11.1884 13.906 10.1684 13.3375 9.47757C12.8882 8.93164 12.388 8.41081 11.9053 7.90241C11.5209 7.49743 10.8789 7.47097 10.4425 7.81943C10.3252 7.91315 10.1795 8.03668 9.88401 8.31366C8.43414 7.45212 7.55543 6.56268 6.7096 5.13925C6.98994 4.84022 7.11358 4.69408 7.20812 4.57559C7.55597 4.13959 7.53015 3.49921 7.12276 3.11825C6.62624 2.65395 6.12094 2.17914 5.5967 1.73979Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutline);
export default __webpack_public_path__ + "static/media/phone-outline.ca5816ee2d550063f3f2149eba2ceae0.svg";
export { ForwardRef as ReactComponent };